// ── Crew Admin ✦ shared palette ─────────────────────────────────
// Softer-than-Crew neon, red reserved for genuine emergencies.
// Constitutional rules: this is a TRUST tool, not a punitive
// dashboard. Tone discipline is one of the platform's biggest
// moats — see PRD §0 + Phase D restraint principles.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BG = '#06061A';
export const PANEL = 'rgba(255,255,255,0.04)';
export const PANEL_BORDER = 'rgba(255,255,255,0.08)';
export const TEXT = '#F5F5FA';
export const TEXT_MUTED = '#9A9ABF';
export const BLUE = '#33C3FF';
export const PURPLE = '#6C3BFF';
export const PINK = '#FF3CAC';
export const GOLD = '#FFD166';
export const DANGER = '#FF5C8A';
export const SAGE = '#5EE3A0';
export const FONT_STACK = "'Space Grotesk', 'Inter', system-ui, sans-serif";
